import { ThunkAction } from "redux-thunk";
import { Action } from "redux";

import { RootState } from "app/redux/reducer";
import { ActivityVariantService } from "./service";
import { showMessage, toggleConfirmDialog, toggleLoader } from "app/redux/system/actions";
import { MessageType } from "app/redux/system/types";
import { IActivityVariant } from "./types";
import { HttpStatusCode, IList, IListFilter } from "app/shared";
import { mapActivityVariantFromEntity, mapActivityVariantFromModel } from "./mapping";
import { setModalData } from "app/redux/modal/actions";

type ThunkResult<R> = ThunkAction<R, RootState, {}, Action>;

export function getActivityVariant(id: string, language?: string, notFill?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityVariantService();
        dispatch(toggleLoader());
        const response = await service.getActivityVariant(id, language || getState().system.defaultLanguage);
        dispatch(toggleLoader());

        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityVariantFromEntity(response.data.attributes["activityVariant"] || {});

            if (!notFill) {
                dispatch(setModalData("activityVariant", mapped));
            }
            return mapped;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}

export function getActivityVariantByLanguage(pageData: IActivityVariant, language: string, isOverride?: boolean): ThunkResult<Promise<any>> {
    return async (dispatch, getState) => {
        const service = new ActivityVariantService();
        dispatch(toggleLoader());
        const response = await service.getActivityVariant(pageData.id as string, isOverride ? getState().system.defaultLanguage : language);
        if (response.status === HttpStatusCode.OK) {
            const mapped = mapActivityVariantFromEntity(response.data.attributes["activityVariant"] || {});
            const data = { ...mapped, language: language, id: isOverride ? pageData.id : mapped.id };
            dispatch(setModalData("activityVariant", data));
            if (isOverride) {
                dispatch(updateActivityVariant(data));
            }
            dispatch(toggleLoader());
            return true;
        }
        else {
            dispatch(toggleConfirmDialog(true, {
                title: "Uyarı!",
                text: `Geçerli dil'e (${language}) ait bir kayıt bulunamadı. Varsayılan dil üzerinden seçtiğiniz dile göre kayıt oluşturulsun mu?`,
                button: {
                    approveText: "Varsayılan Dil'den Oluştur"
                },
                callback: () => {
                    dispatch(createActivityVariant({ ...pageData, id: "", title: `${pageData.title} (${language.toUpperCase()})`, language, artists: [], placeId: "" })).then(res => {
                        if (res) {
                            dispatch(getActivityVariant(res.id as string, language));
                        }
                    });
                    return true;
                }
            }))
        }
        dispatch(toggleLoader());
        return false;
    };
}


export function getActivityVariants(options: IListFilter): ThunkResult<Promise<IList<IActivityVariant[]> | null>> {
    return async (dispatch) => {
        const service = new ActivityVariantService();
        dispatch(toggleLoader());
        const response = await service.getActivityVariants(options);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            const mapped = (response?.data?.attributes?.list || []).map((item) =>
                mapActivityVariantFromEntity(item)
            );

            return {
                list: mapped,
                pageSize: response.data.attributes.pageSize,
                totalCount: response.data.attributes.total,
                pageCount: Math.ceil(response.data.attributes.total / response.data.attributes.pageSize)
            }
        }

        return null;
    };
}

export function createActivityVariant(request: IActivityVariant): ThunkResult<Promise<IActivityVariant | null>> {
    return async (dispatch) => {
        const service = new ActivityVariantService();
        dispatch(toggleLoader());
        const response = await service.createActivityVariant(mapActivityVariantFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return mapActivityVariantFromEntity(response.data.attributes["activityVariant"] || {});
        }
        return null;
    };
}

export function publishActivityVariant(ids: string[]): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityVariantService();
        dispatch(toggleLoader());
        const response = await service.publishActivityVariant(ids);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true
        }
        return false;
    };
}

export function publishActivityVariantByActivity(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityVariantService();
        dispatch(toggleLoader());
        const response = await service.publishActivityVariantByActivity(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true
        }
        return false;
    };
}

export function updateActivityVariant(request: IActivityVariant): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityVariantService();
        dispatch(toggleLoader());
        const response = await service.updateActivityVariant(mapActivityVariantFromModel(request));
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        return false;
    };
}

export function deleteActivityVariant(id: string): ThunkResult<Promise<boolean>> {
    return async (dispatch) => {
        const service = new ActivityVariantService();
        dispatch(toggleLoader());
        const response = await service.deleteActivityVariant(id);
        dispatch(toggleLoader());
        if (response.status === HttpStatusCode.OK) {
            return true;
        }
        dispatch(showMessage("Bir hata oluştu. Servis sağlayıcınızla iletişime geçin ya da daha sonra tekrar deneyiniz!", "Bir Hata Oluştu!", MessageType.ERROR))
        return false;
    };
}